import { ReactNode } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useJsApiLoader, Libraries } from '@react-google-maps/api';
import { Backdrop, Box, CircularProgress } from '@mui/material';
import { Res } from '../../resources';

interface AuthenticatedAppProps {
  children: ReactNode;
}

const googleMapsLibraries: Libraries = ['places'];

const AuthenticatedApp = ({ children }: AuthenticatedAppProps) => {
  const { isLoading: isAuthLoading, isAuthenticated } = useAuth0();
  const { isLoaded: isGoogleLoaded } = useJsApiLoader({
    googleMapsApiKey: Res.components.maps.GOOGLE_TOKEN,
    libraries: googleMapsLibraries,
  });

  return (
    <Box display="flex" flexDirection="column" height="100%">
      {children}

      <Backdrop
        open={isAuthLoading || !isAuthenticated || !isGoogleLoaded}
        sx={(theme) => ({
          color: 'var(--gentian-secondary)',
          bgcolor: 'var(--gentian-white)',
          zIndex: theme.zIndex.drawer + 1,
        })}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default AuthenticatedApp;
